// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.turbo-mode_turbo-container_E5cjR {
    display: flex;
    align-items: center;
    padding: 0.25rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.turbo-mode_turbo-icon_e6vb4 {
    margin: 0.25rem;
}

.turbo-mode_turbo-label_ZHyo1 {
    font-size: 0.625rem;
    font-weight: bold;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: var(--control-primary);
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/turbo-mode/turbo-mode.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,2DAA2D;IAC3D,6BAA6B;IAC7B,mBAAmB;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.turbo-container {\n    display: flex;\n    align-items: center;\n    padding: 0.25rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.turbo-icon {\n    margin: 0.25rem;\n}\n\n.turbo-label {\n    font-size: 0.625rem;\n    font-weight: bold;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    color: var(--control-primary);\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"turbo-container": `turbo-mode_turbo-container_E5cjR`,
	"turboContainer": `turbo-mode_turbo-container_E5cjR`,
	"turbo-icon": `turbo-mode_turbo-icon_e6vb4`,
	"turboIcon": `turbo-mode_turbo-icon_e6vb4`,
	"turbo-label": `turbo-mode_turbo-label_ZHyo1`,
	"turboLabel": `turbo-mode_turbo-label_ZHyo1`
};
export default ___CSS_LOADER_EXPORT___;
